<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Словари</strong>
                </CCardHeader>
                <CCardBody>
                    <EntityTabLinks />
                    <CRow class="pl-3 pb-3" />

                    <CForm>

                        <CTabs
                            variant="pills"
                            :active-tab="0"
                        >
                            <CTab title="Статусы" class="pt-1">
                                <Statuses :entity="entity" />
                            </CTab>

                            <CTab title="Пуши для клиентов" class="pt-1">
                                <Pushes
                                    :entity="entity"
                                    @save="save"
                                    @goBack="goBack"
                                />
                            </CTab>

                        </CTabs>
                    </CForm>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import EntityTabLinks from '@/components/entities/EntityTabLinks';
    import Statuses from '@/components/dictionaries/Statuses';
    import Pushes from '@/components/dictionaries/Pushes';

    export default {

        name: 'EntityDictionary',
        components: {
            EntityTabLinks,
            Statuses,
            Pushes,
        },

        data: () => ({
            entity: {}
        }),

        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/entities/get/${id}`)).data;
        },

        methods: {
            async save(pushes) {
                try {
                    await this.axios.post(`/entities/${this.entity.id}/dictionary/pushes`, pushes);
                    this.$router
                        .push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
                } catch (error) {
                    this.$root.$emit('showError', 'Ошибка сохранения картинок.')
                }
            },
            goBack() {
                this.$router
                    .push({ path: `/entities/${this.$route.params.code}/${this.$route.params.id}` });
            },
        },
    };
</script>
